import { Pagination } from 'antd'
import styled from 'styled-components'

/** 备注：目前只针对暗黑主题写了样式 */
export const MyPagination = styled(Pagination)`
  color: #fff;
  display: flex;
  .ant-pagination-total-text {
    flex: 1;
  }
  .ant-pagination-item {
    background-color: ${props => props.theme['neutral-300']} !important;
    border-radius: 3px;
    margin: 0 4px !important;
    &:hover {
      border-color: transparent;
    }
    a {
      color: #fff;
    }
  }
  .ant-pagination-item-active {
    color: #fff;
    background-color: ${props => props.theme.primary} !important;
    a {
      color: #fff;
    }
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    color: #fff;
  }

  .ant-pagination-disabled .ant-pagination-item-link,
  .ant-pagination-disabled:hover .ant-pagination-item-link {
    color: ${props => props.theme['neutral-300']};
  }

  .ant-pagination-options-quick-jumper input {
    border-color: transparent;
    background-color: ${props => props.theme['neutral-300']} !important;
    color: #fff;
    line-height: 16px;
    width: 32px !important;
  }

  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis {
    color: #fff;
  }
`
